import { MATERIAL_TYPES } from '@mixtiles/web-backend-shared'
import { type StylingFields } from './TilesStore.types'
import { getUrlParam } from 'utils/UrlUtils'
import { URL_PARAM_KEYS } from 'pages/PhotoStyler/tileCustomization.consts'
import {
  FALLBACK_STYLE,
  FALLBACK_NOT_CLASSIC_MATERIAL_STYLE,
  type BulkMaterial,
} from 'pages/PhotoStyler/TileDesignerConsts'
import {
  isFramedMaterial,
  loadMaterialType,
  validateMaterialType,
} from 'utils/materialTypeUtils'
import { experimentManager } from 'services/ExperimentManager/ExperimentManager'

export function getFallbackStyleForMaterials(
  bulkMaterials: BulkMaterial[]
): StylingFields {
  return bulkMaterials.some((bulkMaterial) => !isFramedMaterial(bulkMaterial))
    ? FALLBACK_NOT_CLASSIC_MATERIAL_STYLE
    : FALLBACK_STYLE
}

export function getDefaultMaterialType(): MATERIAL_TYPES {
  const requestedMaterialType =
    getUrlParam(URL_PARAM_KEYS.MATERIAL) || loadMaterialType()
  if (validateMaterialType(requestedMaterialType)) {
    return requestedMaterialType as MATERIAL_TYPES
  }
  return experimentManager.isEnabled('canvas-as-default-tile')
    ? MATERIAL_TYPES.CANVAS
    : MATERIAL_TYPES.CLASSIC
}
